import { RescheduleDriveRequestBody } from '@/api/main/types.gen'
import { DriveFormValues } from './DriveFormModal'

type DriveSubintervalLike = {
  vehicle_id: string
  interval: { starting_from: string; ending_at: string }
  drives: Array<{ id: number; start_after: string }>
}

const toMs = (timestamp: string) => new Date(timestamp).getTime()

const calculateScheduleBeforeDrive = (
  destinationIndex: number,
  destinationDrives: Array<{ id: number }>
): number | undefined => {
  if (destinationIndex === 0 && destinationDrives.length > 0) {
    return destinationDrives[0]?.id
  }
  return undefined
}

const calculateScheduleAfterDrive = (
  destinationIndex: number,
  destinationDrives: Array<{ id: number }>
): number | undefined => {
  if (destinationIndex === 0) {
    return undefined
  }
  if (destinationIndex === destinationDrives.length) {
    return destinationDrives[destinationDrives.length - 1]?.id
  }
  if (destinationIndex > 0 && destinationIndex < destinationDrives.length) {
    return destinationDrives[destinationIndex - 1]?.id
  }
  return undefined
}

export const buildEditRescheduleBody = ({
  driveId,
  fallbackVehicleId,
  values,
  driveSubintervals,
}: {
  driveId: number
  fallbackVehicleId: string
  values: DriveFormValues
  driveSubintervals: DriveSubintervalLike[]
}): RescheduleDriveRequestBody => {
  const destinationVehicleId = values.vehicle_id || fallbackVehicleId
  const exactMatchInterval = driveSubintervals.find(
    interval =>
      interval.vehicle_id === destinationVehicleId &&
      toMs(values.start_after) === toMs(interval.interval.starting_from) &&
      toMs(values.finish_before) === toMs(interval.interval.ending_at)
  )

  if (!exactMatchInterval) {
    return {
      scheduled_drive_id: driveId,
      destination_vehicle_id: destinationVehicleId,
      interval_start: values.start_after,
      interval_end: values.finish_before,
    }
  }

  const destinationDrives = exactMatchInterval.drives.filter(intervalDrive => intervalDrive.id !== driveId)
  const insertionIndex = destinationDrives.findIndex(
    intervalDrive => toMs(values.start_after) < toMs(intervalDrive.start_after)
  )
  const destinationIndex = insertionIndex === -1 ? destinationDrives.length : insertionIndex
  const scheduleBeforeDrive = calculateScheduleBeforeDrive(destinationIndex, destinationDrives)
  const scheduleAfterDrive = calculateScheduleAfterDrive(destinationIndex, destinationDrives)
  const body: RescheduleDriveRequestBody = {
    scheduled_drive_id: driveId,
    destination_vehicle_id: destinationVehicleId,
    interval_start: exactMatchInterval.interval.starting_from,
    interval_end: exactMatchInterval.interval.ending_at,
  }
  if (scheduleBeforeDrive !== undefined) {
    body.schedule_before_drive = scheduleBeforeDrive
  } else if (scheduleAfterDrive !== undefined) {
    body.schedule_after_drive = scheduleAfterDrive
  }
  return body
}
